export const dateFormat = 'MMM d, yyyy';
export const dateShortFormat = 'MM/dd/yy';
export const timeFormat = 'hh:mm a';
// export const dateTimeFormat = 'hh:mm a, MMM d, yyyy';
